import { Stack } from "@mui/material";
import ItineraryButton from "./ItineraryButton";
import RemarksButton from "./RemarksButton";
import WhatMakesThisTourUniqueButton from "./WhatMakesThisTourUniqueButton";
import WhatsIncludedButton from "./WhatsIncludedButton";

export type ExtraInfoInclusion = {
  index: number;
  title: string | null;
  description: string | null;
  icon: string | null;
};

type ExtraInfoProps = {
  highlights: string | null | undefined;
  inclusions: ExtraInfoInclusion[] | null | undefined;
  itinerary: string | null | undefined;
  remarks: string | null | undefined;
};

export default function ExtraInfo({
  highlights,
  inclusions,
  itinerary,
  remarks,
}: ExtraInfoProps) {
  return (
    <Stack
      sx={{
        borderBottom: "1px solid #eef1f5",
        borderTop: "1px solid #eef1f5",
        mt: "16px",
      }}
    >
      <WhatMakesThisTourUniqueButton content={highlights} />
      <WhatsIncludedButton inclusions={inclusions} />
      <ItineraryButton content={itinerary} />
      <RemarksButton content={remarks} />
    </Stack>
  );
}
